// extracted by mini-css-extract-plugin
export default {"container":"ElectricityCostLeft_container__k3tWQ","titleRow":"ElectricityCostLeft_titleRow__8bnLm"};